import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { Card } from "@redotech/arbiter/card";
import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import { memo } from "react";
import { useRateCalculatorDispatch } from "./hooks";
import { RateCalculatorProvider } from "./oms-pricing-tool-context";
import { RateCalculatorWizard } from "./oms-pricing-tool-wizard";

const RateCalculatorCardContent = memo(function RateCalculatorCardContent() {
  const dispatch = useRateCalculatorDispatch();

  return (
    <>
      <Card title="OMS pricing tool" w="full">
        <Flex dir="column" gap="md">
          <Text fontSize="sm">
            Analyze merchant shipping data, check carrier eligibility, and
            generate competitive rate quotes. Upload a carrier invoice or use
            historical shipment data to calculate optimal pricing.
          </Text>
          <Flex>
            <RedoButton
              hierarchy="primary"
              onClick={() => dispatch({ type: "OPEN_WIZARD" })}
              size="sm"
              text="Open OMS pricing tool"
            />
          </Flex>
        </Flex>
      </Card>
      <RateCalculatorWizard />
    </>
  );
});

export const RateCalculatorCard = memo(function RateCalculatorCard() {
  return (
    <RateCalculatorProvider>
      <RateCalculatorCardContent />
    </RateCalculatorProvider>
  );
});
